import { Marketplace } from "@front/m19-api-client";

export const defaultHeadlineLimit = 50;

export function headlineLimit(marketplace: Marketplace): number {
  return marketplace === Marketplace.JP ? 35 : defaultHeadlineLimit;
}
